import React, { useEffect, useState, useRef } from "react";
import API from "../../../../services/api";
import Text from "../../../atoms/text/Text";
import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import EditableText, {
  Handles as EditableTextHandles,
} from "../../../atoms/text/EditableText";
import Clickable from "../../../atoms/clickable/Clickable";
import Icon from "../../../atoms/icon/Icon";
import { formatDuration, parseDuration } from "../utils/durationUtils";

interface Props {
  reportingTemplateId: string;
  layout: API.ReportingTemplateLayoutResponse;
  onFinish: () => void;
}

export const DurationEstimateEdit: React.FC<Props> = ({
  reportingTemplateId,
  layout,
  onFinish,
}) => {
  const [formattedDuration, setFormattedDuration] = useState(
    formatDuration(layout.durationEstimate || 60),
  );
  const [editableTextKey, setEditableTextKey] = useState(layout.id);
  const editableTextRef = useRef<EditableTextHandles>(null);

  useEffect(() => {
    const newDuration = layout.durationEstimate || 60;
    setFormattedDuration(formatDuration(newDuration));
  }, [layout]);

  const handleDurationChange = async (formattedDuration: string) => {
    const newDuration = parseDuration(formattedDuration);
    if (isNaN(newDuration) || newDuration < 0) {
      editableTextRef.current?.reset();
      return;
    }
    const formattedNewDuration = formatDuration(newDuration);
    setFormattedDuration(formattedNewDuration);
    setEditableTextKey(editableTextKey + 1);
    await API.updateReportingTemplateLayout(reportingTemplateId, layout.id, {
      durationEstimate: newDuration,
    });
    onFinish();
  };

  return (
    <InlineGroup verticalCenter spaceBetweenElements={2}>
      <InlineGroup>
        <Text>Duration:</Text>
      </InlineGroup>
      <InlineGroup spaceBetweenElements={2}>
        <EditableText
          key={editableTextKey}
          size="md"
          ref={editableTextRef}
          type="text"
          onChange={handleDurationChange}
          value={formattedDuration}
        />
        <Clickable onClick={() => editableTextRef.current?.setIsEditing(true)}>
          <Icon
            noMargin
            type="edit"
            tip={{ content: "Edit Duration", id: "edit-duration" }}
          />
        </Clickable>
      </InlineGroup>
    </InlineGroup>
  );
};
